import { ShieldCheck } from "lucide-react";

import { ParceirosV2HeroForm } from "@/components/parceiros-v2/ParceirosV2HeroForm";
import { WaveBars } from "./AssessoresHero";

const NUMEROS = [
  { value: "10 anos", label: "de mercado" },
  { value: "100%", label: "de adimplência" },
];

/**
 * Variante do hero da /assessores com o formulário na primeira dobra, no
 * mesmo arranjo 7/5 usado em ParceirosHero: copy à esquerda, form à direita
 * (embaixo no mobile). O `id="form"` vive dentro do próprio ParceirosV2HeroForm,
 * então os CTAs com `href="#form"` e o sticky mobile continuam funcionando.
 */
export const AssessoresV2Hero = () => {
  return (
    <section className="relative bg-[#FAF8F5] overflow-hidden pt-8 sm:pt-14">
      <WaveBars />
      <div className="container-wide px-6 sm:px-6 md:px-12 pb-16 sm:pb-20 md:pb-24 relative">
        <div className="grid gap-10 lg:gap-16 lg:grid-cols-12 items-start">
          {/* Coluna esquerda — texto (60% desktop) */}
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#34F285]/[0.06] pl-2 pr-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-white text-[#2E694D]">
                <ShieldCheck className="w-3 h-3" />
              </span>
              Parceria para profissionais independentes
            </span>

            <h1
              className="mt-5 sm:mt-6 text-[#323F4F] font-extrabold leading-[1.12] tracking-tight text-[2rem] sm:text-[2.5rem] md:text-[3rem] max-w-2xl"
              style={{
                fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                letterSpacing: "-0.02em",
              }}
            >
              Aumente sua receita recorrente divulgando o{" "}
              <span className="text-[#2E694D]">crédito estruturado da Allu</span>.
            </h1>

            <p className="mt-4 sm:mt-5 text-base sm:text-lg font-semibold text-[#2E694D] max-w-2xl">
              Para Consultores de Investimentos, Assessores Autônomos e
              Educadores Financeiros.
            </p>

            <p className="mt-5 sm:mt-6 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-xl">
              A Allu oferece debêntures securitizadas para você divulgar e te dá
              todo o suporte para você aumentar os seus ganhos, sem abrir mão da
              sua autonomia.
            </p>

            <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-zinc-200/70 pt-5">
              {NUMEROS.map((n) => (
                <div key={n.label} className="flex items-baseline gap-2">
                  <span
                    className="text-lg sm:text-xl font-extrabold text-[#2E694D]"
                    style={{
                      fontFamily:
                        '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                    }}
                  >
                    {n.value}
                  </span>
                  <span className="text-xs sm:text-sm text-zinc-500">
                    {n.label}
                  </span>
                </div>
              ))}
            </div>

            <p className="mt-5 max-w-xl text-xs sm:text-sm text-zinc-500 leading-relaxed">
              <a
                href="#como-funciona"
                className="font-medium text-[#323F4F] underline underline-offset-4 decoration-zinc-300 hover:decoration-[#2E694D]"
              >
                Ver como funciona
              </a>{" "}
              antes de se candidatar.
            </p>
          </div>

          {/* Coluna direita — form (40% desktop, abaixo no mobile) */}
          <div className="lg:col-span-5">
            <ParceirosV2HeroForm />
          </div>
        </div>
      </div>
    </section>
  );
};
